import React, { useRef, useState, useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// import Home from "./pages/Home";
// import Setup from "./pages/Setup";
// import Interview from "./pages/Interview";
// import Terms from "./pages/Terms";
// import Privacy from "./pages/Privacy";

import { PaymentProvider } from './contexts/PaymentContext';
import { InterviewProvider } from './contexts/InterviewContext';
import { AffiliateProvider } from './contexts/AffiliateContext';

import './App.css';

import PageSlider from './components/PageSlider';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Dots from './components/Dots';
import SessionGuard from './components/SessionGuard';
import Footer from './components/Footer';
import ProtectedAffiliateRoute from './components/ProtectedAffiliateRoute';

const Home = React.lazy(() => import('./pages/Home'));
const Setup = React.lazy(() => import('./pages/Setup'));
const Interview = React.lazy(() => import('./pages/Interview'));
const Terms = React.lazy(() => import('./pages/Terms'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const Feedback = React.lazy(() => import('./pages/Feedback'));
const HowToUse = React.lazy(() => import('./pages/HowToUse'));
const SessionEnded = React.lazy(() => import('./pages/SessionEnded'));
const AffiliateLogin = React.lazy(() => import('./pages/AffiliateLogin'));
const AffiliateDashboard = React.lazy(() => import('./pages/AffiliateDashboard'));

const routes = [
  { path: '/', element: <Home /> },
  { path: '/setup', element: <Setup /> },
  { path: '/session-ended', element: <SessionEnded /> },
  {
    path: '/interview',
    element: (
      <SessionGuard>
        <Interview />
      </SessionGuard>
    ),
  },
  { path: '/terms', element: <Terms /> },
  { path: '/privacy', element: <Privacy /> },
  { path: '/feedback', element: <Feedback /> },
  { path: '/how-to-use', element: <HowToUse /> },
  { path: '/affiliate/login', element: <AffiliateLogin /> },
  {
    path: '/affiliate/dashboard',
    element: (
      <ProtectedAffiliateRoute>
        <AffiliateDashboard />
      </ProtectedAffiliateRoute>
    ),
  },
];

const AnimatedRoutes = () => {
  const location = useLocation();
  const historyStack = useRef([]);
  const [direction, setDirection] = useState('forward');

  useEffect(() => {
    const currentPath = location.pathname;
    const index = historyStack.current.indexOf(currentPath);

    if (index === -1) {
      historyStack.current.push(currentPath);
      setDirection('forward');
    } else {
      historyStack.current = historyStack.current.slice(0, index + 1);
      setDirection('back');
    }
  }, [location.pathname]);

  return (
    <PageSlider key={location.pathname} direction={direction}>
      <Routes location={location}>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
    </PageSlider>
  );
};

const App = () => {
  return (
    <Router basename='/auron'>
      <ScrollToTop />
      <PaymentProvider>
        <InterviewProvider>
          <AffiliateProvider>
            <Navbar />
            <Suspense fallback={<Dots />}>
              <AnimatedRoutes />
            </Suspense>
            <Footer />
          </AffiliateProvider>
        </InterviewProvider>
      </PaymentProvider>
    </Router>
  );
};

export default App;
